import React from "react";
import { motion } from "framer-motion";

import ara from "../../accests/common/ara.jpeg"
import sigiri from "../../accests/sigiri/sigiri (3).jpeg"
import kan from "../../accests/kan/kan (3).jpeg"
import kand from "../../accests/kan/kan (9).jpeg"
import ellaa from "../../accests/ella/train.jpeg"
import yala from "../../accests/yala/yaala (4).jpeg"

const dayHighlights = [
    {
        day: "Day 1 – Arrival in Sri Lanka",
        title: "Transfer to Negombo",
        desc: "Upon arrival at Colombo International Airport, you will be greeted and transferred to Negombo, a charming coastal town. Check in to your hotel and enjoy free time exploring the local beaches, vibrant fish markets, or colonial-era Dutch canals.",
        img: ara,
    },
    {
        day: "Day 2 – Sigiriya",
        title: "The Iconic Lion Rock & Pinnawala Elephant Orphanage",
        desc: "Begin your journey towards Sigiriya, stopping en route at a Pineapple Garden and the Pinnawala Elephant Orphanage, where rescued elephants are cared for. In the afternoon, visit the Sigiriya Rock Fortress, a UNESCO-listed site towering 600 feet above the jungle. Climb to admire ancient frescoes, rock gardens, and breathtaking views.",
        img: sigiri,
    },
    {
        day: "Day 3 – Kandy",
        title: "Cultural Capital & Temple of the Tooth",
        desc: "Visit the Dambulla Cave Temple, a well-preserved cave monastery with over 150 Buddha statues. Continue to Matale's spice garden, then arrive in Kandy, home to the Temple of the Tooth Relic. Enjoy a Kandyan cultural dance performance before checking in to your hotel.",
        img: kan,

    },
    {
        day: "Day 4 – Nuwara Eliya",
        title: "Royal Botanical Gardens & Tea Plantation",
        desc: "Visit the Royal Botanical Gardens in Peradeniya with over 4,000 plant species. Head to Nuwara Eliya, known as 'Little England', stop at Ramboda Falls, and explore a tea plantation and factory. Learn about tea-making and taste world-renowned Ceylon tea.",
        img: kand,
    },
    {
        day: "Day 5 – Ella & Yala",
        title: "Scenic Train Journey & Wildlife Adventure",
        desc: "Board the scenic train from Nanu Oya to Ella, enjoying lush tea plantations, waterfalls, and misty mountains. Explore the Nine Arch Bridge, hike Little Adam’s Peak, and later drive to Yala National Park, home to diverse wildlife including leopards and elephants.",
        img: ellaa,
    },
    {
        day: "Day 6 – Yala Safari & Bentota",
        title: "Safari & Coastal Relaxation",
        desc: "Wake up early for a 3-hour jeep safari in Yala National Park to spot leopards, elephants, and exotic birds. Then head to Bentota, stopping at Weligama Fish Market, see stilt fishermen in Koggala, and explore Galle Dutch Fort. End the day at Bentota's golden beaches.",
        img: yala,
    },
    {
        day: "Day 7 – Departure",
        title: "Transfer to Colombo Airport",
        desc: "Enjoy a leisurely morning at Bentota Beach or optional water sports. Later, transfer to Colombo Airport for your departure, marking the end of your unforgettable Sri Lanka Discovery Tour.",
        img: ara,
    },
];

const info = [
    { label: "Trip Duration", value: "7 Days" },
    { label: "Language", value: "English" },
    { label: "Best Time to Travel", value: "Year-round" },
    { label: "Transfers", value: "Hotel – Tour Attractions – Hotel" },
];

const inclusions = [
    "Private air-conditioned vehicle (Car/Van/Mini Coach/Luxury Bus)",
    "Comfortable accommodation on a Half Board basis",
    "English speaking professional guides",
    "Entrance fees for all UNESCO Heritage sites",
    "Safari Jeep & other tour activities",
    "Unlimited bottled water throughout the tour",
    "All government taxes & tariffs included",
];

const exclusions = [
    "Additional meals & beverages beyond the meal plan",
    "Visa and flight bookings",
    "Personal expenses, tips, and portage",
];

const travelTips = [
    "Not suitable for guests with reduced mobility",
    "Dress Code - Modest attire required for temple visits (no exposed shoulders or knees)",
    "Wear cotton clothes, bring your camera, and stay hydrated",
    "Hat, Passport, extra cash, Bathing gear, Sunblock, insect repellent, Sunglasses, Comfortable clothing",
];

export default function SriLankaDiscoveryTour() {
    return (


        <div className="overflow-x-hidden">

            {/* Hero Section */}
            <section className="relative h-[70vh] w-full overflow-hidden lg:mt-20">
                <img
                    src={kand}
                    alt="Sri Lanka Discovery Tour"
                    className="w-full h-full object-cover"
                />
                <div
                    className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/40 flex flex-col items-center justify-center text-center px-4">
                    <h1 className="text-4xl md:text-5xl text-white font-bold mb-3">
                        Sri Lanka Discovery Tour
                    </h1>
                    <p className="text-lg md:text-xl text-white/90 max-w-3xl">
                        A 7-day handcrafted journey through Sri Lanka’s best highlights, blending heritage, nature,
                        adventure, and relaxation.
                    </p>
                </div>
            </section>


            <div className="max-w-7xl mx-auto px-4 py-16 space-y-16">
            {/* Day Highlights */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="space-y-12">
                {dayHighlights.map((item, idx) => (
                    <motion.div
                        key={idx}
                        initial={{opacity: 0, x: idx % 2 === 0 ? -50 : 50}}
                        whileInView={{opacity: 1, x: 0}}
                        viewport={{once: true}}
                        className={`md:flex md:items-center md:space-x-8 bg-white shadow-lg rounded-xl overflow-hidden ${
                            idx % 2 === 1 ? "md:flex-row-reverse" : ""
                        }`}
                    >
                        <img
                            src={item.img}
                            alt={item.title}
                            className="md:w-1/2 h-64 object-cover"
                        />
                        <div className="p-6 md:w-1/2">
                            <h3 className="text-2xl font-bold mb-2">{item.day}</h3>
                            <h4 className="text-xl font-semibold mb-4">{item.title}</h4>
                            <p className="text-gray-700">{item.desc}</p>
                        </div>
                    </motion.div>
                ))}
            </section>

            {/* Info Section */}
            <section data-aos="fade-up"
                     data-aos-duration="3000"
                     className="bg-yellow-50 p-8 rounded-xl shadow-lg grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {info.map((item, idx) => (
                    <div key={idx} className="text-center">
                        <h4 className="text-lg font-semibold">{item.label}</h4>
                        <p className="text-gray-700">{item.value}</p>
                    </div>
                ))}
            </section>

            {/* Inclusions & Exclusions */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="grid md:grid-cols-2 gap-8">
                <div className="bg-white p-6 rounded-xl shadow-lg">
                    <h3 className="text-2xl font-bold mb-4">Tour Inclusions</h3>
                    <ul className="list-disc list-inside space-y-2 text-gray-700">
                        {inclusions.map((i, idx) => (
                            <li key={idx}>{i}</li>
                        ))}
                    </ul>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-lg">
                    <h3 className="text-2xl font-bold mb-4">Tour Exclusions</h3>
                    <ul className="list-disc list-inside space-y-2 text-gray-700">
                        {exclusions.map((e, idx) => (
                            <li key={idx}>{e}</li>
                        ))}
                    </ul>
                </div>
            </section>

            {/* Travel Tips */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="bg-gray-50 p-6 rounded-xl shadow-lg">
                <h3 className="text-2xl font-bold mb-4">Travel Tips</h3>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                    {travelTips.map((tip, idx) => (
                        <li key={idx}>{tip}</li>
                    ))}
                </ul>
            </section>

            {/* WhatsApp CTA */}
            <motion.div
                initial={{opacity: 0, y: 40}}
                whileInView={{opacity: 1, y: 0}}
                transition={{duration: 0.8}}
                className="mt-14 text-center"
            >
                <motion.a
                    whileHover={{scale: 1.08}}
                    whileTap={{scale: 0.95}}
                    href="https://wa.me/94770163670?text=Hello%20I%20would%20like%20to%20book%20the%20Sri%20Lanka%20Discovery%20Tour.%20Please%20share%20availability%20and%20pricing.%20Thank%20you."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-14 py-4 bg-green-600 text-white font-semibold text-lg rounded-full shadow-xl hover:bg-green-500 transition-all duration-300"
                >
                    Book This Tour
                </motion.a>
                <p className="mt-4 text-sm text-gray-600">
                    💬 Instant WhatsApp Support • 🏞️ Full Sri Lanka Experience • 🚙 Comfortable Private Transport
                </p>
            </motion.div>
        </div>
        </div>
    );
}
